// Traducción de errores del backend por CÓDIGO estable.
// El backend adjunta {code, msg} (msg en español como respaldo); aquí se
// traduce el code al idioma activo. Los códigos que no estén aquí usan el msg.
export const ERR = {
  es: {
    invalid_amount: "Importe no válido",
    not_authenticated: "No autenticado",
    session_invalid: "Sesión no válida o caducada",
    account_disabled: "Cuenta desactivada",
    impersonation_invalid: "Suplantación no válida o caducada",
    impersonation_readonly: "La suplantación es de solo lectura",
    accountant_readonly: "El contable tiene acceso de solo lectura",
    not_during_impersonation: "No disponible durante la suplantación",
    admin_only: "Solo el administrador puede acceder",
    no_permission: "No tienes permiso para esta acción",
    password_too_short: "La contraseña debe tener al menos 8 caracteres",
    too_many_attempts: "Demasiados intentos. Prueba de nuevo en unos minutos.",
    bad_credentials: "Correo o contraseña incorrectos",
    google_failed: "No se pudo validar la sesión de Google",
    no_refresh_token: "No hay token de actualización",
    invalid_token: "Token no válido",
    user_not_found: "Usuario no encontrado",
    session_revoked: "Sesión revocada",
    reset_link_used: "Enlace no válido o ya usado",
    reset_link_expired: "El enlace ha caducado",
    mfa_enroll_expired: "La inscripción caducó, reinténtalo",
    invalid_code: "Código no válido",
    mfa_required: "Verificación en dos pasos requerida",
    mfa_locked: "Verificación caducada o bloqueada. Inicia sesión de nuevo.",
    name_empty: "El nombre no puede estar vacío",
    category_duplicate: "Ya existe una categoría con ese nombre en este ámbito.",
    system_category_no_delete: "Las categorías del sistema no se pueden borrar; puedes ocultarlas (archivar).",
    invalid_kind: "Tipo no válido",
    invalid_scope: "Ámbito no válido",
    nothing_to_update: "Nada que actualizar",
    not_found_or_forbidden: "No encontrado o sin permiso",
    payment_not_found: "Pago no encontrado",
    invalid_type: "Tipo inválido",
    movement_not_found: "Movimiento no encontrado",
    upload_origin_forbidden: "Origen no permitido para la subida de archivos",
    file_content_invalid: "El contenido del archivo no corresponde a un PDF o imagen válidos.",
    file_too_large: "Archivo demasiado grande (máx 5 MB)",
    file_type_forbidden: "Tipo de archivo no permitido",
    document_not_found: "Documento no encontrado",
    search_empty: "El texto a buscar no puede estar vacío",
    no_active_subscription: "Sin suscripción Stripe activa.",
    no_active_subscription_paid: "Sin suscripción Stripe activa (el plan de pago solo se cambia vía Stripe).",
    invalid_month: "Mes no válido (usa YYYY-MM).",
    monthly_reports_upgrade: "Los informes mensuales están disponibles en tu plan superior.",
    manager_view_premium: "La vista de gestor está disponible en tu plan Premium.",
    invalid_email: "Email no válido",
    cannot_invite_self: "No puedes invitarte a ti mismo",
    manager_already_invited: "Ya existe una invitación o acceso para ese gestor",
    invitation_not_found: "Invitación no encontrada",
    invitation_revoked: "La invitación fue revocada por el cliente",
    no_active_client_access: "No tienes acceso activo a este cliente",
    payments_coming_soon_free: "Pagos próximamente. El acceso gratuito sigue disponible sin tarjeta.",
    payments_coming_soon: "Pagos próximamente.",
    no_stripe_customer: "No hay cliente de Stripe todavía",
    admin_only_prices: "Solo el administrador puede editar los precios",
    client_not_found: "Cliente no encontrado",
    cannot_impersonate_staff: "No se puede suplantar a personal interno",
    support_consent_missing: "El cliente no ha autorizado el acceso de soporte (o ha caducado).",
    demo_only: "Solo disponible en una sesión demo",
    demo_link_invalid: "Enlace de demo no válido. Usa el enlace de invitación que te han enviado.",
  },
  en: {
    invalid_amount: "Invalid amount",
    not_authenticated: "Not authenticated",
    session_invalid: "Invalid or expired session",
    account_disabled: "Account disabled",
    impersonation_invalid: "Invalid or expired impersonation",
    impersonation_readonly: "Impersonation is read-only",
    accountant_readonly: "The accountant has read-only access",
    not_during_impersonation: "Not available during impersonation",
    admin_only: "Only the administrator can access",
    no_permission: "You don't have permission for this action",
    password_too_short: "Password must be at least 8 characters",
    too_many_attempts: "Too many attempts. Try again in a few minutes.",
    bad_credentials: "Incorrect email or password",
    google_failed: "Could not validate the Google session",
    no_refresh_token: "No refresh token",
    invalid_token: "Invalid token",
    user_not_found: "User not found",
    session_revoked: "Session revoked",
    reset_link_used: "Invalid or already used link",
    reset_link_expired: "The link has expired",
    mfa_enroll_expired: "Enrollment expired, try again",
    invalid_code: "Invalid code",
    mfa_required: "Two-step verification required",
    mfa_locked: "Verification expired or locked. Sign in again.",
    name_empty: "The name can't be empty",
    category_duplicate: "A category with that name already exists in this scope.",
    system_category_no_delete: "System categories can't be deleted; you can hide them (archive).",
    invalid_kind: "Invalid type",
    invalid_scope: "Invalid scope",
    nothing_to_update: "Nothing to update",
    not_found_or_forbidden: "Not found or no permission",
    payment_not_found: "Payment not found",
    invalid_type: "Invalid type",
    movement_not_found: "Movement not found",
    upload_origin_forbidden: "Origin not allowed for file upload",
    file_content_invalid: "The file content is not a valid PDF or image.",
    file_too_large: "File too large (max 5 MB)",
    file_type_forbidden: "File type not allowed",
    document_not_found: "Document not found",
    search_empty: "The search text can't be empty",
    no_active_subscription: "No active Stripe subscription.",
    no_active_subscription_paid: "No active Stripe subscription (the paid plan can only be changed via Stripe).",
    invalid_month: "Invalid month (use YYYY-MM).",
    monthly_reports_upgrade: "Monthly reports are available on your higher plan.",
    manager_view_premium: "The manager view is available on your Premium plan.",
    invalid_email: "Invalid email",
    cannot_invite_self: "You can't invite yourself",
    manager_already_invited: "An invitation or access already exists for that manager",
    invitation_not_found: "Invitation not found",
    invitation_revoked: "The invitation was revoked by the client",
    no_active_client_access: "You don't have active access to this client",
    payments_coming_soon_free: "Payments coming soon. Free access remains available without a card.",
    payments_coming_soon: "Payments coming soon.",
    no_stripe_customer: "No Stripe customer yet",
    admin_only_prices: "Only the administrator can edit prices",
    client_not_found: "Client not found",
    cannot_impersonate_staff: "Internal staff can't be impersonated",
    support_consent_missing: "The client hasn't authorized support access (or it has expired).",
    demo_only: "Only available in a demo session",
    demo_link_invalid: "Invalid demo link. Use the invitation link you were sent.",
  },
  fr: {
    invalid_amount: "Montant non valide",
    not_authenticated: "Non authentifié",
    session_invalid: "Session non valide ou expirée",
    account_disabled: "Compte désactivé",
    impersonation_invalid: "Usurpation non valide ou expirée",
    impersonation_readonly: "L'usurpation est en lecture seule",
    accountant_readonly: "Le comptable a un accès en lecture seule",
    not_during_impersonation: "Indisponible pendant l'usurpation",
    admin_only: "Seul l'administrateur peut accéder",
    no_permission: "Vous n'avez pas la permission pour cette action",
    password_too_short: "Le mot de passe doit comporter au moins 8 caractères",
    too_many_attempts: "Trop de tentatives. Réessayez dans quelques minutes.",
    bad_credentials: "E-mail ou mot de passe incorrect",
    google_failed: "Impossible de valider la session Google",
    no_refresh_token: "Aucun jeton de rafraîchissement",
    invalid_token: "Jeton non valide",
    user_not_found: "Utilisateur introuvable",
    session_revoked: "Session révoquée",
    reset_link_used: "Lien non valide ou déjà utilisé",
    reset_link_expired: "Le lien a expiré",
    mfa_enroll_expired: "L'inscription a expiré, réessayez",
    invalid_code: "Code non valide",
    mfa_required: "Vérification en deux étapes requise",
    mfa_locked: "Vérification expirée ou bloquée. Reconnectez-vous.",
    name_empty: "Le nom ne peut pas être vide",
    category_duplicate: "Une catégorie avec ce nom existe déjà dans ce périmètre.",
    system_category_no_delete: "Les catégories système ne peuvent pas être supprimées ; vous pouvez les masquer (archiver).",
    invalid_kind: "Type non valide",
    invalid_scope: "Périmètre non valide",
    nothing_to_update: "Rien à mettre à jour",
    not_found_or_forbidden: "Introuvable ou sans permission",
    payment_not_found: "Paiement introuvable",
    invalid_type: "Type non valide",
    movement_not_found: "Mouvement introuvable",
    upload_origin_forbidden: "Origine non autorisée pour l'envoi de fichiers",
    file_content_invalid: "Le contenu du fichier n'est pas un PDF ou une image valide.",
    file_too_large: "Fichier trop volumineux (max 5 Mo)",
    file_type_forbidden: "Type de fichier non autorisé",
    document_not_found: "Document introuvable",
    search_empty: "Le texte de recherche ne peut pas être vide",
    no_active_subscription: "Aucun abonnement Stripe actif.",
    no_active_subscription_paid: "Aucun abonnement Stripe actif (le plan payant se change uniquement via Stripe).",
    invalid_month: "Mois non valide (utilisez AAAA-MM).",
    monthly_reports_upgrade: "Les rapports mensuels sont disponibles dans votre forfait supérieur.",
    manager_view_premium: "La vue gestionnaire est disponible dans votre forfait Premium.",
    invalid_email: "E-mail non valide",
    cannot_invite_self: "Vous ne pouvez pas vous inviter vous-même",
    manager_already_invited: "Une invitation ou un accès existe déjà pour ce gestionnaire",
    invitation_not_found: "Invitation introuvable",
    invitation_revoked: "L'invitation a été révoquée par le client",
    no_active_client_access: "Vous n'avez pas d'accès actif à ce client",
    payments_coming_soon_free: "Paiements bientôt disponibles. L'accès gratuit reste disponible sans carte.",
    payments_coming_soon: "Paiements bientôt disponibles.",
    no_stripe_customer: "Pas encore de client Stripe",
    admin_only_prices: "Seul l'administrateur peut modifier les prix",
    client_not_found: "Client introuvable",
    cannot_impersonate_staff: "Impossible d'usurper le personnel interne",
    support_consent_missing: "Le client n'a pas autorisé l'accès du support (ou il a expiré).",
    demo_only: "Disponible uniquement dans une session démo",
    demo_link_invalid: "Lien de démo non valide. Utilisez le lien d'invitation qui vous a été envoyé.",
  },
  pt: {
    invalid_amount: "Valor inválido",
    not_authenticated: "Não autenticado",
    session_invalid: "Sessão inválida ou expirada",
    account_disabled: "Conta desativada",
    impersonation_invalid: "Representação inválida ou expirada",
    impersonation_readonly: "A representação é só de leitura",
    accountant_readonly: "O contabilista tem acesso só de leitura",
    not_during_impersonation: "Indisponível durante a representação",
    admin_only: "Só o administrador pode aceder",
    no_permission: "Não tem permissão para esta ação",
    password_too_short: "A palavra-passe deve ter pelo menos 8 caracteres",
    too_many_attempts: "Demasiadas tentativas. Tente novamente dentro de minutos.",
    bad_credentials: "Email ou palavra-passe incorretos",
    google_failed: "Não foi possível validar a sessão Google",
    no_refresh_token: "Sem token de atualização",
    invalid_token: "Token inválido",
    user_not_found: "Utilizador não encontrado",
    session_revoked: "Sessão revogada",
    reset_link_used: "Ligação inválida ou já usada",
    reset_link_expired: "A ligação expirou",
    mfa_enroll_expired: "A inscrição expirou, tente de novo",
    invalid_code: "Código inválido",
    mfa_required: "Verificação em duas etapas necessária",
    mfa_locked: "Verificação expirada ou bloqueada. Inicie sessão de novo.",
    name_empty: "O nome não pode estar vazio",
    category_duplicate: "Já existe uma categoria com esse nome neste âmbito.",
    system_category_no_delete: "As categorias do sistema não podem ser eliminadas; pode ocultá-las (arquivar).",
    invalid_kind: "Tipo inválido",
    invalid_scope: "Âmbito inválido",
    nothing_to_update: "Nada para atualizar",
    not_found_or_forbidden: "Não encontrado ou sem permissão",
    payment_not_found: "Pagamento não encontrado",
    invalid_type: "Tipo inválido",
    movement_not_found: "Movimento não encontrado",
    upload_origin_forbidden: "Origem não permitida para o envio de ficheiros",
    file_content_invalid: "O conteúdo do ficheiro não é um PDF ou imagem válidos.",
    file_too_large: "Ficheiro demasiado grande (máx 5 MB)",
    file_type_forbidden: "Tipo de ficheiro não permitido",
    document_not_found: "Documento não encontrado",
    search_empty: "O texto a pesquisar não pode estar vazio",
    no_active_subscription: "Sem subscrição Stripe ativa.",
    no_active_subscription_paid: "Sem subscrição Stripe ativa (o plano pago só se altera via Stripe).",
    invalid_month: "Mês inválido (use AAAA-MM).",
    monthly_reports_upgrade: "Os relatórios mensais estão disponíveis no seu plano superior.",
    manager_view_premium: "A vista de gestor está disponível no seu plano Premium.",
    invalid_email: "Email inválido",
    cannot_invite_self: "Não pode convidar-se a si mesmo",
    manager_already_invited: "Já existe um convite ou acesso para esse gestor",
    invitation_not_found: "Convite não encontrado",
    invitation_revoked: "O convite foi revogado pelo cliente",
    no_active_client_access: "Não tem acesso ativo a este cliente",
    payments_coming_soon_free: "Pagamentos em breve. O acesso gratuito continua disponível sem cartão.",
    payments_coming_soon: "Pagamentos em breve.",
    no_stripe_customer: "Ainda não há cliente Stripe",
    admin_only_prices: "Só o administrador pode editar os preços",
    client_not_found: "Cliente não encontrado",
    cannot_impersonate_staff: "Não é possível representar pessoal interno",
    support_consent_missing: "O cliente não autorizou o acesso do suporte (ou expirou).",
    demo_only: "Só disponível numa sessão demo",
    demo_link_invalid: "Ligação de demo inválida. Use a ligação de convite que lhe enviaram.",
  },
  it: {
    invalid_amount: "Importo non valido",
    not_authenticated: "Non autenticato",
    session_invalid: "Sessione non valida o scaduta",
    account_disabled: "Account disattivato",
    impersonation_invalid: "Impersonificazione non valida o scaduta",
    impersonation_readonly: "L'impersonificazione è di sola lettura",
    accountant_readonly: "Il commercialista ha accesso in sola lettura",
    not_during_impersonation: "Non disponibile durante l'impersonificazione",
    admin_only: "Solo l'amministratore può accedere",
    no_permission: "Non hai il permesso per questa azione",
    password_too_short: "La password deve avere almeno 8 caratteri",
    too_many_attempts: "Troppi tentativi. Riprova tra qualche minuto.",
    bad_credentials: "Email o password errati",
    google_failed: "Impossibile convalidare la sessione Google",
    no_refresh_token: "Nessun token di aggiornamento",
    invalid_token: "Token non valido",
    user_not_found: "Utente non trovato",
    session_revoked: "Sessione revocata",
    reset_link_used: "Link non valido o già usato",
    reset_link_expired: "Il link è scaduto",
    mfa_enroll_expired: "L'iscrizione è scaduta, riprova",
    invalid_code: "Codice non valido",
    mfa_required: "Verifica in due passaggi richiesta",
    mfa_locked: "Verifica scaduta o bloccata. Accedi di nuovo.",
    name_empty: "Il nome non può essere vuoto",
    category_duplicate: "Esiste già una categoria con quel nome in questo ambito.",
    system_category_no_delete: "Le categorie di sistema non possono essere eliminate; puoi nasconderle (archiviare).",
    invalid_kind: "Tipo non valido",
    invalid_scope: "Ambito non valido",
    nothing_to_update: "Niente da aggiornare",
    not_found_or_forbidden: "Non trovato o senza permesso",
    payment_not_found: "Pagamento non trovato",
    invalid_type: "Tipo non valido",
    movement_not_found: "Movimento non trovato",
    upload_origin_forbidden: "Origine non consentita per il caricamento di file",
    file_content_invalid: "Il contenuto del file non è un PDF o un'immagine validi.",
    file_too_large: "File troppo grande (max 5 MB)",
    file_type_forbidden: "Tipo di file non consentito",
    document_not_found: "Documento non trovato",
    search_empty: "Il testo da cercare non può essere vuoto",
    no_active_subscription: "Nessun abbonamento Stripe attivo.",
    no_active_subscription_paid: "Nessun abbonamento Stripe attivo (il piano a pagamento si cambia solo tramite Stripe).",
    invalid_month: "Mese non valido (usa AAAA-MM).",
    monthly_reports_upgrade: "I report mensili sono disponibili nel tuo piano superiore.",
    manager_view_premium: "La vista gestore è disponibile nel tuo piano Premium.",
    invalid_email: "Email non valida",
    cannot_invite_self: "Non puoi invitare te stesso",
    manager_already_invited: "Esiste già un invito o un accesso per quel gestore",
    invitation_not_found: "Invito non trovato",
    invitation_revoked: "L'invito è stato revocato dal cliente",
    no_active_client_access: "Non hai accesso attivo a questo cliente",
    payments_coming_soon_free: "Pagamenti in arrivo. L'accesso gratuito resta disponibile senza carta.",
    payments_coming_soon: "Pagamenti in arrivo.",
    no_stripe_customer: "Ancora nessun cliente Stripe",
    admin_only_prices: "Solo l'amministratore può modificare i prezzi",
    client_not_found: "Cliente non trovato",
    cannot_impersonate_staff: "Non è possibile impersonare personale interno",
    support_consent_missing: "Il cliente non ha autorizzato l'accesso del supporto (o è scaduto).",
    demo_only: "Disponibile solo in una sessione demo",
    demo_link_invalid: "Link demo non valido. Usa il link di invito che ti è stato inviato.",
  },
};
